// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"143011c9","667":"f5add69a"}[chunkId] + ".chunk.js";
};